import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "components/PublicHeader";
import PublicFooter from "components/PublicFooter";

const PublicLayout = (props: React.PropsWithChildren) => {
  const { children } = props;

  return (
    <div
      className={"h-[100vh] w-full flex flex-col justify-between items-center"}
    >
      <PublicHeader />
      <Outlet />
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
